import { render, staticRenderFns } from "./DairyKe.vue?vue&type=template&id=5e9e3e32&"
import script from "./DairyKe.vue?vue&type=script&lang=js&"
export * from "./DairyKe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports